import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminHeader from "../Header/AdminHeader";
import AdminFooter from "../Footer/AdminFooter";
import AdminLeftMenu from "../Navbar/AdminLeftMenu";
import AdvanceDataTable from "../UI/Table/AdvanceDataTable";
import { AGENT_PLAN_LIST } from "../UI/Table/ColumnConst";
import { NODE_HOST_URL } from "../Dashboard/api/Api";
import { userloginDetails } from "../Utils/AdminAuth";
import Axios from "../../axios/Axios";
import Spining from "../UI/Spining/Spining";

const AgentPlan = () => {
    const lStorage = userloginDetails();

    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;

    const [planList, setPlanList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedPlanId, setSelectedPlanId] = useState(null);

    const [successMessage, setSuccessMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [bgColor, setBgColor] = useState("alert alert-success alert-dismissible");

    const fetchPlanList = async () => {
        setIsLoading(true);
        try {
            const payload = {
                user_id: userId,
                token: userToken,
                method: "agent&flow_plans_retrieve",
            }
            const response = await Axios.post(`${NODE_HOST_URL}/admin/plans`, payload);;

            const result = response.data;
            if (result.success === true) {
                setPlanList(result.data);
                setSuccessMessage(false);
            }
            else {
                setPlanList([]);
            }
        }
        catch (error) {
            setPlanList([]);
            setSuccessMessage(true);
            setBgColor("alert alert-danger alert-dismissible");
            setErrorMessage(error.message || "Something went wrong. Please try again later.");
        } finally {
            setIsLoading(false);
        }
    }

    const handleDelete = (id) => {
        setSelectedPlanId(id);
        setShowDeleteModal(true);
    };

    const confirmDelete = async () => {
        try {
            const payload = {
                user_id: userId,
                token: userToken,
                method: "agent&flow_plans_delete",
                id: selectedPlanId
            };

            const response = await Axios.post(
                `${NODE_HOST_URL}/admin/plans`,
                payload
            );

            const result = response.data;

            if (result.success === true) {
                setBgColor("alert alert-success alert-dismissible");
                setErrorMessage(result.message);
                fetchPlanList();
            } else {
                setBgColor("alert alert-danger alert-dismissible");
                setErrorMessage(result.message);
            }

            setSuccessMessage(true);
        } catch (error) {
            setBgColor("alert alert-danger alert-dismissible");
            setErrorMessage("Something went wrong!");
            setSuccessMessage(true);
        } finally {
            setShowDeleteModal(false);
            setSelectedPlanId(null);
        }
    };

    useEffect(() => {
        fetchPlanList();
    }, []);

    return (
        <div className="wrapper">
            <AdminLeftMenu />

            <div className="main">
                <AdminHeader />

                <main className="content">
                    <div className="container-fluid p-0">

                        <div className="row mb-2 mb-xl-3 align-items-center">
                            <div className="col-auto d-none d-sm-block">
                                <h3>
                                    <strong>
                                        Agent Plan
                                    </strong>
                                </h3>
                            </div>
                            <div className="col-auto ml-auto">
                                <Link
                                    to="/admin/add-agent-plan"
                                    className="btn btn-primary btn-sm"
                                >
                                    Add Plan
                                </Link>
                            </div>
                        </div>
                        {/* ALERT MESSAGE */}
                        {successMessage && (
                            <div className={bgColor} role="alert">
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="alert"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">×</span>
                                </button>
                                <div>{errorMessage}</div>
                            </div>
                        )}
                        <div className="row">
                            <div className="col-12 col-lg-12 col-xxl-12 d-flex">
                                {/* <div className="card flex-fill"> */}
                                <div className="card-body p-0">

                                    {/* DATA TABLE */}
                                    {isLoading ? (
                                        <Spining />
                                    ) : planList.length > 0 ? (
                                        <AdvanceDataTable
                                            tableCell={AGENT_PLAN_LIST(handleDelete)}
                                            tableData={planList}
                                            pagination={true}
                                            filterstatus={true}
                                        />
                                    ) : (
                                        <div className="text-center py-4 text-muted">
                                            No records found
                                        </div>
                                    )}
                                </div>
                                {/* </div> */}
                            </div>
                        </div>

                    </div>
                </main>

                <AdminFooter />
            </div>
            {showDeleteModal && (
                <>
                    <div className="modal fade show d-block" tabIndex="-1">
                        <div className="modal-dialog modal-sm modal-dialog-centered">
                            <div className="modal-content">

                                <div className="modal-header">
                                    <h5 className="modal-title">Confirm Delete</h5>
                                    <button
                                        type="button"
                                        className="close"
                                        onClick={() => setShowDeleteModal(false)}
                                    >
                                        <span>&times;</span>
                                    </button>
                                </div>

                                <div className="modal-body text-center">
                                    <p className="mb-0">
                                        Are you sure you want to delete this plan?
                                    </p>
                                </div>

                                <div className="modal-footer justify-content-center">
                                    <button
                                        className="btn btn-secondary btn-sm"
                                        onClick={() => setShowDeleteModal(false)}
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        className="btn btn-danger btn-sm"
                                        onClick={confirmDelete}
                                    >
                                        Delete
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>

                    {/* BACKDROP */}
                    <div className="modal-backdrop fade show"></div>
                </>
            )}

        </div>
    );
};

export default AgentPlan;
